import { Receipt } from 'lucide-react';
import { formatRange } from './utils';
import { formatMinor, TaxReportCard, TaxStatCell, TaxStatStrip } from './taxReportShared';

interface VatBox {
  box: number;
  label: string;
  valueMinor: number;
}

interface Data {
  type: string;
  periodStart: string;
  periodEnd: string;
  boxes: VatBox[];
  netVatDueMinor: number;
}

export function TaxVatReturnReport({ data }: { data: Record<string, unknown> }) {
  const d = data as unknown as Data;
  const boxes = d.boxes ?? [];

  return (
    <TaxReportCard
      icon={Receipt}
      title="VAT Return"
      badge={formatRange(d.periodStart, d.periodEnd)}
    >
      <TaxStatStrip>
        <TaxStatCell label="Net VAT due" value={formatMinor(d.netVatDueMinor, 'GBP')} emphasis />
      </TaxStatStrip>

      <table className="w-full text-sm">
        <thead>
          <tr className="bg-surface-50/60 text-[11px] uppercase tracking-[0.06em] text-surface-500">
            <th className="px-4.5 py-2 text-left font-medium">Box</th>
            <th className="px-3 py-2 text-left font-medium">Description</th>
            <th className="px-4.5 py-2 text-right font-medium">Amount</th>
          </tr>
        </thead>
        <tbody>
          {boxes.map((b) => {
            const highlight = b.box === 5;
            return (
              <tr
                key={b.box}
                className={`border-t border-surface-100 transition-colors hover:bg-surface-50 ${
                  highlight ? 'bg-surface-50/60' : ''
                }`}
              >
                <td className="px-4.5 py-1.75 font-mono text-[12px] tabular-nums text-surface-500">
                  {b.box}
                </td>
                <td className="px-3 py-1.75 text-[13px] text-surface-700">{b.label}</td>
                <td
                  className={`px-4.5 py-1.75 text-right font-mono text-[13px] tabular-nums ${
                    highlight ? 'font-semibold text-surface-900' : 'text-surface-600'
                  }`}
                >
                  {formatMinor(b.valueMinor, 'GBP')}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </TaxReportCard>
  );
}
